import React from 'react';

type DiffLine = {
  type: 'add' | 'del' | 'equal';
  text: string;
  left?: number;
  right?: number;
};

type GitDiffPanelProps = {
  filename: string | null;
  diff: DiffLine[];
};

export function GitDiffPanel({ filename, diff }: GitDiffPanelProps) {
  return (
    <div className="console-card">
      <div className="panel-header">
        <div>
          <p className="eyebrow">Git diff</p>
          <h2>{filename ? filename : 'No file selected'}</h2>
        </div>
      </div>
      {filename ? (
        diff.length ? (
          <div className="diff-view">
            {diff.map((line, idx) => (
              <div key={`${line.type}-${idx}-${line.text}`} className={`diff-row ${line.type}`}>
                <span className="diff-gutter">{line.left ?? ''}</span>
                <span className="diff-gutter">{line.right ?? ''}</span>
                <pre className="diff-content">{line.text}</pre>
              </div>
            ))}
          </div>
        ) : (
          <p className="muted">No changes in this file.</p>
        )
      ) : (
        <p className="muted">Select a file to view diff.</p>
      )}
    </div>
  );
}

export default React.memo(GitDiffPanel);
